import Cookies from 'universal-cookie';
const cookies = new Cookies();

export const getCookie = (name: string) => cookies.get(name);
export const setCookie = (name: string, value: string) => cookies.set(name, value, { path: '/' });
